import type { ExpectedType } from './ExpectedType'

/** Locale noun key for every `expected_type` the API emits on FIELD_INVALID_TYPE. */
export const expectedTypeKey = Object.freeze({
  array: 'presentation.errors.expectedType.array',
  boolean: 'presentation.errors.expectedType.boolean',
  flat_object: 'presentation.errors.expectedType.flatObject',
  integer: 'presentation.errors.expectedType.integer',
  numeric: 'presentation.errors.expectedType.numeric',
  object: 'presentation.errors.expectedType.object',
  string: 'presentation.errors.expectedType.string'
} satisfies Record<ExpectedType, `presentation.errors.expectedType.${string}`>)
